// Domain constants for /adresseingabe form

export const ANREDEN = ["Herr", "Frau", "Firma", "Eheleute"];

export const RECHTSFORMEN = [
  "GmbH",
  "UG (haftungsbeschränkt)",
  "AG",
  "GmbH & Co. KG",
  "OHG",
  "KG",
  "GbR",
  "Einzelunternehmen",
  "e.K.",
  "e.V.",
  "Stiftung",
  "Genossenschaft (eG)",
  "Partnerschaftsgesellschaft (PartG)",
  "PartG mbB",
  "SE",
  "Sonstige",
];

// Deutsche Registerarten — RA-Micro-kompatible Kürzel
export const REGISTER_ARTEN = [
  { code: "HRA", label: "HRA — Handelsregister Abt. A (Einzelkfm., OHG, KG)" },
  { code: "HRB", label: "HRB — Handelsregister Abt. B (GmbH, UG, AG, KGaA)" },
  { code: "GnR", label: "GnR — Genossenschaftsregister" },
  { code: "PR",  label: "PR — Partnerschaftsregister" },
  { code: "VR",  label: "VR — Vereinsregister" },
];
